import { useRef } from 'react';

/**
 * Hook to prevent duplicate API calls in React StrictMode
 * Returns a function that ensures the callback is only called once per component lifecycle
 */
export const useStrictModeGuard = () => {
  const hasExecutedRef = useRef(false);

  const executeOnce = (callback: () => void, resetKey?: string) => {
    if (!hasExecutedRef.current) {
      hasExecutedRef.current = true;
      callback();
    }
  };

  const reset = () => {
    hasExecutedRef.current = false;
  };

  return { executeOnce, reset };
};
